module.exports = __webpack_public_path__ + "static/media/statementPreference.85870907.svg";